export const sanitizeObject = (filters: any) =>
  Object.entries(filters)
    .filter(([_, v]) => Boolean(v))
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {});
